<div class="row" style="margin-bottom:10px" id="attachments_inline">
  <div class="col-md-12">
    <div class="panel panel-default" *ngIf="meta | async as m">
      <div class="panel-heading" (click)="getItems()">
        <h4 class="panel-title">
          <a role="button">
            <span *ngIf="loading"><i class="fa fa-spinner fa-pulse"></i></span>
            <i *ngIf="!attachmentsLoaded && !loading" class="pull-left fa fa-chevron-down"></i>
            <i *ngIf="attachmentsLoaded && attachIsCollapsed && !loading && attachments.length !== 0"
               class="pull-left fa fa-chevron-down"></i>
            <i *ngIf="attachmentsLoaded && !attachIsCollapsed && attachments.length > 0"
               class="pull-left fa fa-chevron-up"></i>
            <span *ngIf="attachmentsLoaded && attachments.length === 0">No </span> {{ m.verbose_name_plural }}
          </a>
          <div *ngIf="m.permissions.write && disableEditing !== true" class="pull-right" style="position: sticky; right: 0;">
                                <span style="cursor: pointer;" (click)="open($event)">Add {{ m.verbose_name }}
                                  <i class="fa fa-plus-circle"></i></span>
          </div>
        </h4>
      </div>
      <!--        this is the table -->
      <div class="panel-body table-responsive" *ngIf="attachments && attachments.length > 0 && !loading"
           [ngbCollapse]="attachIsCollapsed">
        <table class="table table-striped">
          <thead>
          <tr>
            <th *ngFor="let key of displayFields"
                [innerHTML]="m.fields[key].label | toTrusted">
            </th>
            <th>Attachment</th>
            <th *ngIf="m.permissions.write" style="width:25px">Delete</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of attachments">
            <td *ngFor="let key of displayFields">
              <!--                (click)="m.permissions.write && open(foreignKey, item, $event)">-->
              <app-display-field [type]="m.fields[key].type" [value]="item[key]"
                                 [choices]="m.fields[key].choices"></app-display-field>
            </td>
            <td>
              <!--               download-->
              <a *ngIf="!(item.filetype | isImage)" (click)="$event.stopPropagation()" style="cursor: pointer;" ngbTooltip="Click to open/download."
                 [href]="getDownloadUrl(item)" target="_blank"
                 container="body">
                <img style="max-width: 18px;" src="/assets/very-basic-file-icon.png"/>
                {{ item.filename }}
              </a>

              <ng-container *ngIf="(item.filetype | isImage)">
                <ng-template #attachmentTooltip>
                  <img src="data:image/JPEG;base64,{{item.base64}}" height="200px">
                </ng-template>
                <a (click)="$event.stopPropagation()" style="cursor: pointer;" [ngbTooltip]="attachmentTooltip"
                   [href]="getDownloadUrl(item)" target="_blank"
                   container="body">
                  <img style="max-width: 18px;" src="/assets/very-basic-file-icon.png"/>
                  {{ item.filename }}
                </a>
              </ng-container>
            </td>
            <td *ngIf="m.print !== undefined" style="cursor: pointer; vertical-align: middle;">
              <a href="/api/{{m.type}}/{{item.globalid}}/{{m.print}}/" target="_blank"
                 style="text-decoration: none; color: black;">
                <i class="fa fa-print fa-lg" style="padding:0px 30%;"></i>
              </a>
            </td>
            <td *ngIf="m.permissions.write" style="cursor: pointer; vertical-align: middle;"
                (click)="delete(item)"><i
              class="fa fa-times-circle-o fa-lg"
              style="padding:0px 30%;"></i></td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="attachments.length < m.count">
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">
                <a role="button" class="text-center" (click)="loadMore()" *ngIf="!loadingMore && attachments.length > 0">
                  Load More Records
                </a>
                <span *ngIf="loadingMore">
                  <i class="fa fa-spinner fa-pulse"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
